module.exports = __webpack_public_path__ + "6819c37bf38fb00b773608eb51b91bf6.svg";